import { render, staticRenderFns } from "./Confirmacion.vue?vue&type=template&id=548bb2e2&scoped=true&"
import script from "./Confirmacion.vue?vue&type=script&lang=js&"
export * from "./Confirmacion.vue?vue&type=script&lang=js&"
import style0 from "./Confirmacion.vue?vue&type=style&index=0&id=548bb2e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548bb2e2",
  null
  
)

export default component.exports